export enum StatusEnum {
  Active = 'ACTIVE',
  PendingActivation = 'PENDING_ACTIVATION',
  Suspended = 'SUSPENDED',
  Draft = 'DRAFT',
  Closed = 'CLOSED',
  RecentlyClosed = 'RECENTLY_CLOSED',
  Terminated = 'TERMINATED',
  NotIncluded = 'NOT_INCLUDED'
}
